import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.relation.review');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-relation-review',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.relation.review/view.scss */
:host {
  display: block;
  height: 100%;
}

.kg-relation-source {
  word-break: keep-all;
  overflow-wrap: anywhere;
}`],
})
export class PageRelationReviewComponent implements OnInit {
    public loading: boolean = false;
    public panelLoading: boolean = false;
    public saving: boolean = false;
    public compiling: boolean = false;
    public error: any = null;

    public run: any = null;
    public runs: any[] = [];
    public selectedRunKey: string = '';
    public counts: any = {};
    public ontology: any[] = [];
    public revision: number = 0;
    public artifactSha256: string = '';
    public lastCompilation: any = null;

    public statusFilter: string = 'pending';
    public predicateFilter: string = '';
    public riskFilter: string = '';
    public query: string = '';
    public page: number = 1;
    public result: any = this.emptyPage();
    public selected: any = null;
    public historyItems: any[] = [];

    public formPredicate: string = '';
    public formSwap: boolean = false;
    public formAssertion: string = 'asserted';
    public formEvidenceStart: number = 0;
    public formEvidenceEnd: number = 0;
    public formTemporalText: string = '';
    public formNote: string = '';

    public manualOpen: boolean = false;
    public manualSubjectId: string = '';
    public manualObjectId: string = '';
    public manualPredicate: string = '';
    public manualStart: number = 0;
    public manualEnd: number = 0;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        await this.loadOverview();
        await this.loadRuns();
    }

    public async loadOverview() {
        if (this.loading) return;
        this.loading = true;
        this.error = null;
        await this.service.render();
        try {
            const data = await this.call('overview', this.routeIdentity());
            this.run = data.run;
            this.selectedRunKey = this.run.document_key;
            this.counts = data.counts || {};
            this.ontology = data.ontology || [];
            this.revision = data.revision || 0;
            this.artifactSha256 = data.artifact_sha256 || '';
            this.lastCompilation = data.last_compilation || null;
            const candidateId = this.routeCandidateId();
            if (candidateId) {
                this.statusFilter = 'all';
                this.page = 1;
                await this.loadCandidates(false);
                await this.openCandidate(candidateId);
            } else {
                await this.loadCandidates(true);
            }
        } catch (error) {
            this.applyError(error);
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async loadRuns() {
        try {
            const data = await this.call('runs', {});
            this.runs = data.items || [];
        } catch (_error) {
            this.runs = this.run ? [this.run] : [];
        }
        await this.service.render();
    }

    public selectRun(documentKey: string) {
        this.selectedRunKey = documentKey;
        const item = this.runs.find((row: any) => row.document_key === documentKey);
        if (!item || (this.run && item.document_key === this.run.document_key)) return;
        location.href = `/relation-review/${encodeURIComponent(item.document_id)}/${item.version}`;
    }

    public runOptionLabel(item: any) {
        if (!item) return '';
        return `v${item.version} · ${item.document_id} · 후보 ${this.formatNumber(item.candidate_count || 0)}`;
    }

    public async loadCandidates(selectFirst: boolean = false) {
        if (!this.run) return;
        this.panelLoading = true;
        this.error = null;
        await this.service.render();
        try {
            this.result = await this.call('candidates', {
                ...this.identity(),
                status: this.statusFilter,
                predicate: this.predicateFilter,
                risk: this.riskFilter,
                query: this.query,
                page: this.page,
                dump: 60,
            });
            this.revision = this.result.revision;
            this.artifactSha256 = this.result.artifact_sha256;
            if (selectFirst && this.result.items.length) {
                await this.openCandidate(this.result.items[0].id);
            } else if (selectFirst) {
                this.selected = null;
                this.historyItems = [];
            }
        } catch (error) {
            this.applyError(error);
        } finally {
            this.panelLoading = false;
            await this.service.render();
        }
    }

    public async openCandidate(candidateId: string) {
        if (!candidateId) return;
        this.panelLoading = true;
        await this.service.render();
        try {
            this.selected = await this.call('candidate', {
                ...this.identity(),
                candidate_id: candidateId,
            });
            this.revision = this.selected.revision;
            this.artifactSha256 = this.selected.artifact_sha256;
            this.resetDecisionForm();
            await this.loadHistory();
        } catch (error) {
            this.applyError(error);
        } finally {
            this.panelLoading = false;
            await this.service.render();
        }
    }

    public resetDecisionForm() {
        if (!this.selected) return;
        const candidate = this.selected.candidate;
        const decision = this.selected.decision;
        this.formPredicate = decision && decision.predicate
            ? decision.predicate
            : candidate.proposed_predicates[0].predicate;
        this.formSwap = decision ? !!decision.swap_direction : false;
        this.formAssertion = decision && decision.assertion
            ? decision.assertion
            : candidate.assertion;
        const span = decision && decision.evidence_span
            ? decision.evidence_span
            : candidate.evidence_span;
        this.formEvidenceStart = span.start_char;
        this.formEvidenceEnd = span.end_char;
        const qualifiers = decision && decision.qualifiers ? decision.qualifiers : {};
        this.formTemporalText = qualifiers.temporal_text || '';
        this.formNote = qualifiers.note || '';
        this.manualSubjectId = candidate.subject_entity_id;
        this.manualObjectId = candidate.object_entity_id;
        this.manualPredicate = this.formPredicate;
        this.manualStart = span.start_char;
        this.manualEnd = span.end_char;
    }

    public async saveDecision(action: string) {
        if (!this.selected || this.saving) return;
        this.saving = true;
        this.error = null;
        await this.service.render();
        try {
            const data = await this.call('decision', {
                ...this.identity(),
                candidate_id: this.selected.candidate.id,
                action: action,
                predicate: this.formPredicate,
                swap_direction: this.formSwap,
                assertion: this.formAssertion,
                evidence_start: this.formEvidenceStart,
                evidence_end: this.formEvidenceEnd,
                qualifiers: JSON.stringify(this.qualifiers()),
                expected_revision: this.revision,
                artifact_sha256: this.artifactSha256,
            });
            this.revision = data.revision;
            await this.refreshAfterMutation(this.selected.candidate.id);
        } catch (error) {
            this.applyError(error);
        } finally {
            this.saving = false;
            await this.service.render();
        }
    }

    public async addManualRelation() {
        if (!this.selected || this.saving) return;
        this.saving = true;
        this.error = null;
        await this.service.render();
        try {
            const data = await this.call('manual_relation', {
                ...this.identity(),
                source_id: this.selected.candidate.source_record_id,
                subject_entity_id: this.manualSubjectId,
                object_entity_id: this.manualObjectId,
                predicate: this.manualPredicate,
                evidence_start: this.manualStart,
                evidence_end: this.manualEnd,
                expected_revision: this.revision,
                artifact_sha256: this.artifactSha256,
            });
            this.revision = data.revision;
            this.manualOpen = false;
            await this.loadOverview();
            await this.openCandidate(data.candidate.id);
        } catch (error) {
            this.applyError(error);
        } finally {
            this.saving = false;
            await this.service.render();
        }
    }

    public async loadHistory() {
        if (!this.selected) return;
        try {
            const data = await this.call('history', {
                ...this.identity(),
                candidate_id: this.selected.candidate.id,
                limit: 30,
            });
            this.historyItems = data.items || [];
        } catch (_error) {
            this.historyItems = [];
        }
        await this.service.render();
    }

    public async compileTriples() {
        if (!this.run || this.compiling || this.counts.accepted < 1) return;
        const confirmed = await this.service.modal.show({
            title: 'Triple 생성',
            message: `accept 관계 ${this.counts.accepted}건(사람 ${this.counts.human_accepted || 0}, 임시 ${this.counts.provisional_accepted || 0})을 병합합니다. 임시 관계가 있으면 final_output은 false로 유지됩니다.`,
            action: 'Triple 생성',
            cancel: '취소',
            status: 'success',
            actionBtn: 'success',
        });
        if (!confirmed) return;
        this.compiling = true;
        this.error = null;
        await this.service.render();
        try {
            const data = await this.call('compile_triples', {
                ...this.identity(),
                expected_revision: this.revision,
                artifact_sha256: this.artifactSha256,
            });
            this.lastCompilation = {
                run_id: data.run_id,
                review_revision: data.review_revision,
                triple_count: data.triple_count,
                status: data.manifest.status,
                final_output: data.manifest.final_output,
                human_confirmed_triple_count: data.manifest.counts.human_confirmed_triple_count,
                provisional_triple_count: data.manifest.counts.provisional_triple_count,
            };
            await this.loadOverview();
        } catch (error) {
            this.applyError(error);
        } finally {
            this.compiling = false;
            await this.service.render();
        }
    }

    public async applyFilters() {
        this.page = 1;
        await this.loadCandidates(true);
    }

    public async setStatusFilter(status: string) {
        this.statusFilter = status;
        await this.applyFilters();
    }

    public async setPredicateFilter(predicate: string) {
        this.predicateFilter = predicate;
        await this.applyFilters();
    }

    public async setRiskFilter(risk: string) {
        this.riskFilter = risk;
        await this.applyFilters();
    }

    public async movePage(delta: number) {
        const next = this.page + delta;
        if (next < 1 || next > this.totalPages()) return;
        this.page = next;
        await this.loadCandidates(true);
    }

    public async toggleManual() {
        this.manualOpen = !this.manualOpen;
        await this.service.render();
    }

    public async openSidebar() {
        await this.service.status.toggle('navbar', false);
    }

    public openDocuments() {
        location.href = '/documents';
    }

    public openEntityReview() {
        if (!this.run) return;
        location.href = `/entity-review/${encodeURIComponent(this.run.document_id)}/${this.run.version}`;
    }

    public openGraph() {
        if (!this.run || !this.lastCompilation?.final_output) return;
        location.href = `/graph/${encodeURIComponent(this.run.document_id)}/${this.run.version}`;
    }

    public swapLabels() {
        if (!this.selected) return { subject: null, object: null };
        return this.formSwap
            ? { subject: this.selected.object_entity, object: this.selected.subject_entity }
            : { subject: this.selected.subject_entity, object: this.selected.object_entity };
    }

    public evidenceSegments() {
        if (!this.selected || !this.selected.source) return [];
        const text = this.selected.source.text || '';
        const start = Math.max(0, Number(this.formEvidenceStart) || 0);
        const end = Math.min(text.length, Number(this.formEvidenceEnd) || 0);
        return [
            { text: text.slice(0, start), tone: 'plain' },
            { text: text.slice(start, end), tone: 'evidence' },
            { text: text.slice(end), tone: 'plain' },
        ].filter((item: any) => item.text.length > 0);
    }

    public allowedPredicates() {
        if (!this.selected) return this.ontology;
        const labels = this.swapLabels();
        return this.ontology.filter((item: any) => {
            return labels.subject
                && labels.object
                && item.subject_types.indexOf(labels.subject.entity_type) >= 0
                && item.object_types.indexOf(labels.object.entity_type) >= 0;
        });
    }

    public candidateClass(item: any) {
        const base = 'w-full rounded-lg border p-3 text-left transition-colors';
        if (this.selected && this.selected.candidate.id === item.id) {
            return base + ' border-indigo-300 bg-indigo-50 shadow-sm';
        }
        return base + ' border-zinc-200 bg-white hover:border-indigo-200 hover:bg-indigo-50/30';
    }

    public statusClass(status: string) {
        const styles: any = {
            pending: 'border-amber-200 bg-amber-50 text-amber-800',
            accepted: 'border-green-200 bg-green-50 text-green-700',
            excluded: 'border-zinc-200 bg-zinc-100 text-zinc-600',
            held: 'border-violet-200 bg-violet-50 text-violet-700',
        };
        return styles[status] || styles.pending;
    }

    public statusLabel(status: string) {
        const labels: any = {
            pending: '미검수',
            accepted: '확정',
            excluded: '제외',
            held: '보류',
        };
        return labels[status] || status || '-';
    }

    public assertionLabel(assertion: string) {
        const labels: any = {
            asserted: '확정 서술',
            negated: '부정',
            speculative: '추정·가능성',
            reported: '인용·전언',
            conditional: '조건',
        };
        return labels[assertion] || assertion || '-';
    }

    public historyLabel(item: any) {
        const labels: any = {
            decision_saved: '판단 저장',
            decision_reverted: '판단 되돌림',
            manual_relation_added: '수동 관계 추가',
        };
        return labels[item.event_type] || item.event_type;
    }

    public totalPages() {
        return Math.max(1, Math.ceil((this.result.total || 0) / (this.result.dump || 60)));
    }

    public formatNumber(value: any) {
        return Number(value || 0).toLocaleString('ko-KR');
    }

    public shortId(value: string) {
        if (!value) return '-';
        return value.length > 38 ? '…' + value.slice(-36) : value;
    }

    private async refreshAfterMutation(candidateId: string) {
        await this.loadOverview();
        const exists = this.result.items.some((item: any) => item.id === candidateId);
        if (exists) await this.openCandidate(candidateId);
    }

    private qualifiers() {
        const value: any = {};
        if (this.formTemporalText.trim()) value.temporal_text = this.formTemporalText.trim();
        if (this.formNote.trim()) value.note = this.formNote.trim();
        return value;
    }

    private identity() {
        return {
            document_id: this.run.document_id,
            version: this.run.version,
        };
    }

    private routeIdentity() {
        const parts = location.pathname.split('/').filter((part: string) => !!part);
        const index = parts.indexOf('relation-review');
        if (index < 0 || !parts[index + 1]) {
            return { document_id: 'trn_nahf_jj', version: 2 };
        }
        const rawVersion = parts[index + 2] || '2';
        return {
            document_id: decodeURIComponent(parts[index + 1]),
            version: rawVersion.startsWith('v') ? rawVersion.slice(1) : rawVersion,
        };
    }

    private routeCandidateId() {
        return new URLSearchParams(location.search).get('candidateId') || '';
    }

    private async call(name: string, payload: any) {
        const { code, data } = await wiz.call(name, payload || {});
        if (code !== 200) {
            const message = data && data.error && data.error.message
                ? data.error.message
                : '관계 검수 데이터를 처리하지 못했습니다.';
            throw new Error(message);
        }
        return data;
    }

    private applyError(error: any) {
        this.error = {
            message: error && error.message
                ? error.message
                : '관계 검수 데이터를 처리하지 못했습니다.',
        };
    }

    private emptyPage() {
        return { items: [], page: 1, dump: 60, total: 0 };
    }
}

export default PageRelationReviewComponent;